import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-cream text-warm-900 pt-10 md:pt-16 pb-16 md:pb-24 px-4 overflow-hidden" data-id="element-109">
      <div className="max-w-6xl mx-auto" data-id="element-110">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center" data-id="element-111">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="text-center lg:text-left" data-id="element-112">
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.2
          }} className="inline-flex items-center gap-2 mb-6 px-3 py-1.5 rounded-full border border-sage/30 bg-sage/5 text-sage-dark text-xs md:text-sm font-medium tracking-wide" data-id="element-113">
              <span className="w-1.5 h-1.5 rounded-full bg-sage animate-pulse" data-id="element-114" />
              Para personas cansadas de decidir qué cenar
            </motion.div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.05] mb-6 text-warm-900" data-id="element-115">
              ¿Qué Cocino? <br data-id="element-116" />
              <span className="italic text-sage-dark font-medium" data-id="element-117">
                Nunca Más.
              </span>
            </h1>

            <p className="text-lg md:text-xl text-warm-800/80 font-light mb-10 max-w-xl mx-auto lg:mx-0 leading-relaxed" data-id="element-118">
              El sistema de ensamblaje modular para personas cansadas que
              quieren tener la cena resuelta — y la mente tranquila.
            </p>

            <motion.a href="#oferta" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="inline-flex items-center justify-center gap-2 bg-sage-dark text-cream font-semibold py-4 px-8 rounded-full text-base md:text-lg shadow-lg shadow-sage-dark/20 hover:shadow-xl hover:shadow-sage-dark/30 transition-all duration-300" data-id="element-119">
              Quiero la cena resuelta
              <ArrowRightIcon className="w-4 h-4" data-id="element-120" />
            </motion.a>

            <p className="mt-4 text-sm text-warm-800/50" data-id="element-121">
              Un solo pago · Acceso de por vida
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.9,
          delay: 0.2
        }} className="relative" data-id="element-122">
            <div className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl shadow-warm-900/20" data-id="element-123">
              <img src="https://cdn.magicpatterns.com/uploads/tYQz3z1CcF67fpVEcKeF1N/heylloyd-image-1778818124689.png" alt="Sistema de ensamblaje modular - cena resuelta sin pensar" className="w-full h-auto object-cover" data-id="element-124" />
            </div>

            {/* Decorative corner accents */}
            <div className="absolute -bottom-3 -right-3 w-20 h-20 border-b-2 border-r-2 border-sage/40 rounded-br-3xl pointer-events-none hidden md:block" data-id="element-125" />
          </motion.div>
        </div>
      </div>
    </section>;
}